let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("az6W3")).then(() => parcelRequire('5oLnX'));